/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { eventDetailPayoutListConfig } from '../../config/eventDetail.config';
import { Graphql } from '@common/graphql';
import { apiConfig } from '@pages/PayoutListPage/config/api.config';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';

import { toHeaderCase } from 'js-convert-case';
import moment from 'moment';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

const lookup = require('country-code-lookup');

export interface IEventDetailMethods extends IPluginMethodMap {
  getEventDetailProps(args: any): Promise<any>;
}

export class EventDetailPlugin implements IAgentPlugin {
  readonly methods: IEventDetailMethods;

  constructor() {
    this.methods = {
      getEventDetailProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    console.log(`args in format event detail`, args);
    return {
      title: toHeaderCase(args?.stormName ?? ''),
      subTitle: args?.date ? moment(args?.date).format('LLL') : null,
      listItems: this.getListItems(args),
    };
  }

  private getListItems(res: any) {
    console.log('payments', res?.payments);
    let _temp: any = [];
    _temp = eventDetailPayoutListConfig?.listItems?.map((ele: any) => {
      if (ele?.key === 'stormName') {
        return {
          ...ele,
          subTitle: toHeaderCase(res?.stormName ?? '-'),
        };
      }
      if (ele?.key === 'box') {
        return {
          ...ele,
          subTitle: toHeaderCase(res?.exposure ?? '-'),
        };
      }
      if (ele?.key === 'category') {
        return {
          ...ele,
          subTitle: toHeaderCase(res?.category ?? '-'),
        };
      }
      if (ele?.key === 'country') {
        return {
          ...ele,
          subTitle: res?.country
            ? lookup.byIso(`${res?.country}`)?.country
            : '-',
          flag: res?.country,
        };
      }
      if (ele?.key === 'date') {
        return {
          ...ele,
          subTitle: res?.date ? moment(res?.date).format('LLL') : '-',
        };
      }
      if (ele?.key === 'payout') {
        return {
          ...ele,
          subTitle: res?.payoutEstimate ?? '-',
        };
      }
      if (ele?.key === 'maxWindSpeed') {
        return {
          ...ele,
          subTitle: `${res?.vmax ?? '-'} m/s`,
        };
      }
      if (ele?.key === 'minWindSpeed') {
        return {
          ...ele,
          subTitle: `${res?.vmin ?? '-'} m/s`,
        };
      }
    });
    return _temp;
  }
}
